import React from 'react';
import { Main } from './components';

const CreateEditOrders = () => <Main />;

export default CreateEditOrders;
